
export default function AboutSection() {
  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostico');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 lg:py-20 bg-gray-50" id="sobre">
      <div className="container px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            {/* Content */}
            <div className="space-y-6">
              {/* Hidden content for SEO */}
              <div className="hidden">
                <h3>Agência de Marketing no ABC - São Bernardo do Campo</h3>
                <p>
                  A M4 Digital é uma agência de marketing em São Bernardo do Campo especializada em 
                  marketing digital com inteligência artificial. Oferecemos consultoria de marketing digital, 
                  como automatizar vendas, funil de vendas B2B, automação de marketing, CRM e automação para empresas.
                  Nossos serviços incluem como aumentar as vendas da empresa através de inteligência artificial vendas,
                  automação comercial B2B e ferramentas de vendas com IA para aumentar faturamento com automação.
                </p>
                <h4>Serviços de Automação Comercial</h4>
                <p>
                  Implementamos soluções completas de automação comercial B2B incluindo pipeline automatizado,
                  lead scoring automatizado, funil de vendas automatizado, automação WhatsApp empresas,
                  chatbot WhatsApp vendas e CRM com inteligência artificial para empresas do ABC.
                </p>
              </div>

              <div className="space-y-6 lg:space-y-8">
                <div className="space-y-4">
                  <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900">
                    Conheça a
                    <span className="block gradient-text-orange">M4 Digital</span>
                  </h2>
                  <p className="text-lg lg:text-xl text-gray-600 leading-relaxed">
                    <strong>Agência de Marketing em SP</strong> especializada em 
                    <strong>alta performance comercial</strong> e <strong>automação de processos com Inteligência Artificial</strong>.
                  </p>
                </div>
                
                <div className="space-y-4 lg:space-y-6">
                  <div className="flex items-start gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-rocket-line text-orange-600 text-lg lg:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg lg:text-xl font-semibold text-gray-900 mb-2">
                        Como Aumentar as Vendas da Empresa
                      </h3>
                      <p className="text-sm lg:text-base text-gray-600">
                        Mais de 1.200 empresas já experimentaram crescimento exponencial com nossas 
                        <strong> estratégias para aumentar vendas</strong> e <em>automação inteligente de leads</em>.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 bg-red-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-brain-line text-red-600 text-lg lg:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg lg:text-xl font-semibold text-gray-900 mb-2">
                        Marketing Digital com Inteligência Artificial
                      </h3>
                      <p className="text-sm lg:text-base text-gray-600">
                        Implementamos <strong>inteligência artificial vendas</strong> para automatizar processos, 
                        <em>como automatizar vendas</em> e otimizar conversões em tempo real.
                      </p>
                    </div>
                  </div>
                  
                  <div className="flex items-start gap-3 lg:gap-4">
                    <div className="w-10 h-10 lg:w-12 lg:h-12 bg-yellow-100 rounded-lg flex items-center justify-center flex-shrink-0">
                      <i className="ri-line-chart-line text-yellow-600 text-lg lg:text-xl"></i>
                    </div>
                    <div>
                      <h3 className="text-lg lg:text-xl font-semibold text-gray-900 mb-2">
                        Aumentar Faturamento com Automação
                      </h3>
                      <p className="text-sm lg:text-base text-gray-600">
                        Acompanhamento em tempo real com <strong>CRM e automação para empresas</strong>, 
                        métricas claras e ROI comprovado em cada estratégia implementada.
                      </p>
                    </div>
                  </div>
                </div>
                
                <div className="flex flex-col sm:flex-row gap-3 lg:gap-4">
                  <button 
                    onClick={scrollToDiagnostic}
                    className="btn-primary-orange text-sm lg:text-base cursor-pointer"
                  >
                    <i className="ri-calendar-line mr-2"></i>
                    Diagnóstico Gratuito com IA
                  </button>
                </div>
                
              </div>
            </div>

            {/* Image */}
            <div className="relative">
              <img
                src="https://static.readdy.ai/image/60d079db6e314477a5615b4d3efd8435/e00c15122af87c7dcfa15462812cac9f.png"
                alt="Agência de marketing digital com inteligência artificial M4 Digital - CRM automação e funil de vendas automatizado"
                className="w-full h-auto rounded-2xl shadow-2xl object-cover"
                loading="lazy"
              />
              
              {/* Floating stats */}
              <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-4 shadow-xl border">
                <div className="text-2xl font-bold text-orange-500 mb-1">98%</div>
                <div className="text-sm text-gray-600">Satisfação</div>
              </div>
              
              <div className="absolute -top-6 -right-6 bg-white rounded-xl p-4 shadow-xl border">
                <div className="text-2xl font-bold text-red-500 mb-1">24/7</div>
                <div className="text-sm text-gray-600">Suporte IA</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
